<section aria-labelledby="care-heading">
  <h2 id="care-heading">Create General Inquiry Ticket</h2>
  @if (careFormGroup) {
    <form
      [formGroup]="careFormGroup"
      [ngClass]="{ 'form-submit-attempt': formSubmitAttempted() }"
      autocomplete="off"
    >
      <app-primary-reporter
        [formRef]="careFormGroup"
        [reporters]="primaryReporters"
        (usersLoaded)="usersLoaded()"
      ></app-primary-reporter>

      <ng-container *ngxPermissionsOnly="Permission.SERVICES">
        @if (isLoading || services?.length) {
          <app-select-single-service
            [formRef]="careFormGroup"
            [services]="services"
            [selectedServiceId]="selectedServiceId"
            [inlineErrors]="inlineErrors"
            (servicesLoaded)="servicesLoaded()"
          ></app-select-single-service>
        }
      </ng-container>

      <div class="mt-6">
        <label class="comcast-input-label" for="care-subject">
          Subject
          <span class="comcast-required-marker" aria-hidden="true">*</span>
        </label>
        <input
          id="care-subject"
          type="text"
          formControlName="subject"
          class="comcast-input mt-2"
          [ngClass]="{
            'comcast-input-invalid':
              inlineErrors.subject &&
              (careFormGroup.get('subject').dirty || formSubmitAttempted()),
          }"
          placeholder="Tell us about the issue..."
          aria-required="true"
          [attr.aria-invalid]="
            inlineErrors.subject &&
            (careFormGroup.get('subject').dirty || formSubmitAttempted())
          "
          [attr.aria-describedby]="
            inlineErrors.subject &&
            (careFormGroup.get('subject').dirty || formSubmitAttempted())
              ? 'care-subject-error'
              : null
          "
          (keyup)="canSubmit()"
        />
        @if (
          inlineErrors.subject &&
          (careFormGroup.get('subject').dirty || formSubmitAttempted())
        ) {
          <div
            id="care-subject-error"
            class="comcast-validation-error"
            role="alert"
          >
            {{ inlineErrors.subject }}
          </div>
        }
      </div>

      <div class="mt-6">
        <label class="comcast-input-label" for="care-description">
          Please describe the issue(s) you're experiencing
          <span class="comcast-required-marker" aria-hidden="true">*</span>
        </label>
        <textarea
          id="care-description"
          formControlName="description"
          class="comcast-textarea"
          [ngClass]="{
            'comcast-input-invalid':
              inlineErrors.description &&
              (careFormGroup.get('description').dirty || formSubmitAttempted()),
          }"
          rows="5"
          maxlength="2000"
          placeholder="Tell us about the issue..."
          aria-required="true"
          [attr.aria-invalid]="
            inlineErrors.description &&
            (careFormGroup.get('description').dirty || formSubmitAttempted())
          "
          [attr.aria-describedby]="
            inlineErrors.description &&
            (careFormGroup.get('description').dirty || formSubmitAttempted())
              ? 'care-description-error care-description-count'
              : 'care-description-count'
          "
          (keyup)="canSubmit()"
        ></textarea>
        <div class="mt-1 flex items-center justify-between">
          @if (
            inlineErrors.description &&
            (careFormGroup.get('description').dirty || formSubmitAttempted())
          ) {
            <div
              id="care-description-error"
              class="comcast-validation-error !mt-0"
              role="alert"
            >
              {{ inlineErrors.description }}
            </div>
          } @else {
            <div></div>
          }
          <div
            id="care-description-count"
            class="comcast-textarea-count !mt-0"
            aria-live="polite"
            aria-atomic="true"
          >
            {{ careFormGroup.get('description').value?.length || 0 }} / 2000
          </div>
        </div>
      </div>

      @if (submissionError) {
        <div
          class="comcast-error-alert mt-6"
          role="alert"
          aria-live="assertive"
        >
          <mat-icon
            fontSet="material-icons-outlined"
            class="comcast-error-alert-icon"
            aria-hidden="true"
            >warning</mat-icon
          >
          <span class="comcast-error-alert-text">
            {{
              errorMessage || 'Unable to submit the ticket. Please try again!'
            }}
          </span>
        </div>
      }

      <div class="mt-6">
        <button
          class="btn-primary w-full"
          (click)="submitTicket()"
          [disabled]="areServicesLoading() || areUsersLoading() || isSubmitting"
          [attr.aria-busy]="isSubmitting"
          [attr.aria-label]="
            isSubmitting ? 'Submitting ticket, please wait' : 'Submit ticket'
          "
        >
          @if (isSubmitting) {
            <mat-spinner
              [diameter]="20"
              color="accent"
              aria-hidden="true"
            ></mat-spinner>
          } @else {
            Submit ticket
          }
        </button>
      </div>
    </form>
  }
</section>
